export const USER_ACTION_TYPE_ADD_PENDING               =  1;
export const USER_ACTION_TYPE_BAN_PLAYER                =  2;
export const USER_ACTION_TYPE_UNBAN_PLAYER              =  3;
export const USER_ACTION_TYPE_ENFORCE_PLAYER_STATE      =  4;
export const USER_ACTION_TYPE_BLOCK_CHAT                =  6;
export const USER_ACTION_TYPE_CREATE_RESOURCE_LOG_COPY  =  9;
export const USER_ACTION_TYPE_EDIT_PLAYER_STATE         = 10;
export const USER_ACTION_TYPE_SET_INVENTORY_ITEM_AMOUNT = 12;
export const USER_ACTION_TYPE_UNBLOCK_CHAT              = 13;
export const USER_ACTION_TYPE_SET_LEVEL                 = 18;

export function convertUserArrayToMap(userArray) {
  if(userArray === undefined) {
    return null;
  }
  if(userArray === null) {
    return null;
  }

  const userMap = new Map();
  for(let i = 0; i < userArray.length; i++) {
    const user = userArray[i];
    userMap.set(user.id, user);
  }
  return userMap;
}

export function getUserFromMap(userMap, userId) {
  const user = userMap.get(userId);
  if(user === undefined) {
    return {
      id: userId,
    };
  }
  return user;
}
